import { gql } from "@apollo/client";

export const GET_ALL_SOLICITUDES = gql`
query GetAllSolicitudes($input: TraditumSolicitudInput!) {
    allSolicitudTraditum(
        input: $input
    ) {
        success,
        error,
        valorEsperado {
            descripcionEstado
            idPaciente
            paciente
            idPlanCuidado
            planCuidado
            numeroAfiliado
            identificadorPrestadorPrescriptor
            codigoDiagnosticoTraditum
            idCliente
            cliente
            codigoPractica
            cantidadSolicitada
            idSolicitud
            fechaAlta
            fechaPrescripcion
            idEvaluacion
            idEstado
            idUsuario
            numeroTransaccion
            fechaRealizacion
            observacion
        }
    }
}`;